<template>
  <b-row class="d-flex checkbox-stat-panel">
    <b-col v-for="option in options">
      <checkbox-stat-box
          class="checkbox-stat-box"
          size="small"
          :label="option.label"
          :value="option.value"
          :color="option.color"
          :label-color="labelColor"
          :bg-color="option.bgColor"
          :checkbox-name="option.formName"
          :checkbox-value="option.formValue"
          :checkbox-model="model"
          @change="handleChange"
          :checkbox-checked="checked" />
    </b-col>
  </b-row>
</template>

<script>
import CheckboxStatBox from '@/components/Dashboard/CheckboxStatBox';

export default {
  name: "CheckboxStatPanel",
  components: {
    CheckboxStatBox,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    labelColor: {
      type: String,
    },
  },
  data() {
    return {
      model: 0,
    }
  },
  computed: {
    checked() {
      return this.options.filter(({ checked })=> checked).map(({ formValue }) => formValue);
    },
  },
  methods: {
    handleChange(event) {
      this.$emit('change', event);
    },
  }
}
</script>

<style lang="scss">
.checkbox-stat-panel {
  .checkbox-stat-box {
    > .value {
      max-width: 160px;
    }
  }
}

</style>
